package com.patronat.top.client.di

import com.patronat.top.core.di.clientCoreModule
import com.patronat.top.features.auth.di.authFeatureModule
import com.patronat.top.library.media.di.mediaModule
import org.koin.core.module.Module

val clientAppModules: List<Module> = listOf(
    clientCoreModule,
    clientPlatformModule,
    authFeatureModule,
    mediaModule,
    clientAuthModule,
    clientHomeModule
)
